import React from 'react';

const GuestPage = () => (
    <div className="content">
        <h1 className='title'>Guest Teachers</h1>
        <h2 className='teacher'>Bronwen Houck, Guest Teacher / Creative Dance / Substitute</h2>
        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                    <img width="200" src="/images/bronwen2.jpg"/>
                </td>
                <td className='description'>
                    <p>Bronwen Houck is a Seattle native and lifelong dance enthusiast. She
                        began dancing at the Creative Dance Center from a very young age and
                        was a member of Kaleidoscope Dance Company, a professional modern company
                        of young people based in Seattle, from 1984-1993. With Kaleidoscope she
                        performed in and around the Pacific Northwest as well as traveling with
                        the company to Japan, Canada, Australia, and Brazil. Bronwen went on to
                        study modern dance under Ze'eva Cohen at Princeton University. She earned
                        a Certificate in Theatre and Dance as well as a BA in Art History from
                        Princeton. </p>
                    <p>Bronwen is currently on the faculty of the Creative Dance Center in Haller
                        Lake (just up the street from Little Nest!) where she teaches Nurturing
                        Baby and Parent/Child classes. She is so excited to be leading movement
                        classes with the Little Nest students! When she is not teaching dance
                        Bronwen enjoys the adventures of life with two young children (one current
                        Little Nester and one alum) and works as a professional portrait and event
                        photographer
                        (<a href="http://www.bronwenhouckphoto.com">www.bronwenhouckphoto.com</a>).
                    </p>
                    <p>
                        Both of Bronwen's children are Little Nest Alumni.
                    </p>
                </td>
            </tr>
            </tbody>
        </table>

        <h2 className='teacher'>Sabrina Howell, Guest Teacher / Substitute</h2>
        <table>
            <tbody>
            <tr>
                <td className='teacher'>
                  <img width="200" src="/images/Sabrina.png"/>
                </td>
                <td className='description'>
                    <p>
                        As Sabrina enters her second decade as a parent, she is excited to move
                        from her role as a stay at home parent into working with larger groups
                        of children. Sabrina has a bachelor's degree in philosophy and political
                        science from DePaul University and a master's degree in political science
                        from Rutgers University. After working in co-op preschools for six years
                        with her own children, Sabrina is excited to join the loving and nurturing
                        team at Little Nest as a guest teacher. Sabrina believes children need to
                        spend lots of time outside, expressing their physical selves. She also loves
                        helping children fully realize and express their imaginative ideas.
                    </p>
                </td>
            </tr>
            </tbody>
        </table>


    </div>
);

export default GuestPage;



// WEBPACK FOOTER //
// ./src/components/GuestPage.js